"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
/* Where and how to show validation*/
var ValidationDisplay = /** @class */ (function () {
    function ValidationDisplay(displayType, fields) {
        this.displayType = displayType;
        this.fields = fields;
    }
    ValidationDisplay.prototype.getDisplayType = function () {
        return this.displayType;
    };
    ValidationDisplay.prototype.getFields = function () {
        return this.fields;
    };
    return ValidationDisplay;
}());
exports.ValidationDisplay = ValidationDisplay;
//# sourceMappingURL=validation-display.js.map